import { useState } from 'react';
import { Box, Button, InputBase, Modal, Typography, styled } from '@mui/material';
import palette from '../../../../theme/palette';
import { MyCustomModal } from '../../../../components/modal-component/my-custom-modal';
import MyDialog from '../../../../components/dialog-component/my-dialog';
import Image from '../../../../components/Image';

const InputLabel = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '15px',
  opacity: 0.9,
  color: '#fff',
}));

const StyledInput = styled(InputBase)(() => ({
  opacity: 0.9,
  fontWeight: 400,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  backgroundColor: '#d3d3d3',
  color: '#000',
  borderRadius: '10px',
  padding: '8.5px 13px',
  input: {
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
    },
  },
}));

const _verificationForm = {
  verificationCode: '',
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const TryItOutForm = ({ handleClose, handleOpen }) => {
  const [verificationForm, setVerificationCode] = useState(_verificationForm);

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setVerificationCode((prevState) => ({ ...prevState, [name]: value }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // console.log('On submit', verificationForm);
  };

  // console.log(handleOpen);

  return (
    <MyDialog hasFooter open={handleOpen} close={handleClose} maxSize={'sm'}>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <form onSubmit={onSubmit}>
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={2}>
            <Image
              sx={{ width: '283px', height: '115px' }}
              src="https://a865c0.swuacktu.net/system-requirement/Web.PortalNew/UK256-01/162b4dd46c/images/e0f35643deaca7318a5f4c00e9659ecc.png"
            />
            <StyledInput
              fullWidth
              type="text"
              name="verificationCode"
              value={verificationForm.verificationCode}
              placeholder="e.g. 0126668888"
              onChange={handleFormChange}
            />
            <Button
              type="submit"
              fullWidth
              sx={{
                background: 'linear-gradient(to right, #c34029, #ff7214 24%, #dd600f 49%, #ff7214 74%, #c34029)',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '16px',
                textTransform: 'none',
                py: 1.5,
                borderRadius: '8px',
                boxShadow: '0px 0px 10px rgba(255, 114, 20, 0.4)',
                '&:hover': {
                  background: 'linear-gradient(to right, #d64a2f, #ff8a2f 24%, #e86a1b 49%, #ff8a2f 74%, #d64a2f)',
                },
              }}
            >
              Lập Tức Chơi Thử
            </Button>
          </Box>
        </form>
      </Box>
    </MyDialog>
  );
};

export default TryItOutForm;
